import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from './service/home.service';
import { FilterDefaultService } from '../shared/services/filter-default.service';
import { AuthInterceptor } from '../interceptor/auth.interceptor';
import { StorafeUtil } from '../shared/util/storasge.util';
import { CODIGO_CENTRUS, DESABILITAR_MENU_ATUALIZAR_INFORMACOES_CONTATOS, MODO_PERSPECTIVA_ITENS_MENU_USUARIO } from '../../app.constants';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  @BlockUI() blockUi: NgBlockUI;

  pathLocal = '';
  caminhoImagem: string;


  itensPai: any[] = [];


  display: boolean;


  constructor(
    private homeService: HomeService,
    private filterDefaultService: FilterDefaultService,
    private authInterceptor: AuthInterceptor,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this._limparSessionStoragi();
    this.chamarModalAtualizarEmailFone();
  }


  private _limparSessionStoragi(): void {
    const valor = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
    if (!valor) { StorafeUtil.limparSessionStorage(CODIGO_CENTRUS) };
  }


  chamarModalAtualizarEmailFone() {
    // this.blockUi.start('Carregando...');
    this.filterDefaultService.getFilterDefaultCdLogin(this.authInterceptor.getJwtCdLogin())
      .then(res => {
        const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);

        // console.log(res);
        // this.blockUi.stop();

        if (res['dhUltAcesso'] === null && !recuperandoObjeto) { if (this.display = true) { StorafeUtil.gravaSessionStorage(DESABILITAR_MENU_ATUALIZAR_INFORMACOES_CONTATOS, true) } };
      }).catch()
  }



  // this.blockUi.stop()
}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/home/home.component.ts